import { createSysdyneIdPlugin } from '../../../libs/sysdyne-id-client/react/use-sysdyne-id';
import { AuthConfig } from './types/auth-config';
import { getRouterBasename } from '../../utils/get-router-basename';
import { SysdyneIdPluginOptions } from '../../../libs/sysdyne-id-client/react/types';
import { isLocalHost } from '../../utils/is-local-host';
const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://cb.sysdyne.cloud';

export function setupSysdyneIdPlugin(
  options: AuthConfig,
  onAuthStateChanged: SysdyneIdPluginOptions['onAuthStateChanged'],
  onPostRedirectNavigateRequest: SysdyneIdPluginOptions['onPostRedirectNavigateRequest'],
  onRedirectError: SysdyneIdPluginOptions['onRedirectError'],
) {
  const { host, clientId, resource, scope } = options;
  const routerBasename = getRouterBasename();

  const getBaseUrl = () => {
    if (isLocalHost()) {
      return `${window.location.origin}${routerBasename}`;
    }
    return `${BASE_URL}${routerBasename}`;
  };

  return createSysdyneIdPlugin({
    clientOptions: {
      host,
      clientId,
      authorizationParams: {
        resource,
        scope,
      },
    },
    baseUrl: getBaseUrl(),
    callbackPath: `${getRouterBasename()}/auth/sso`,
    onPostRedirectNavigateRequest,
    onAuthStateChanged,
    onRedirectError,
  });
}
